import React, { useState, useEffect } from "react";
import { authApi } from "../../api";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function NewPasswordModal() {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const storedEmail = localStorage.getItem("resetEmail");
        if (storedEmail) setEmail(storedEmail);
    }, []);

    useEffect(() => {
        const el = document.getElementById("newPasswordModal");
        if (!el) return;

        const onShow = () => setNewPassword(""); // Açıldığında kod temizle
        const onShow2 = () => setConfirmPassword("");

        el.addEventListener("shown.bs.offcanvas", onShow, onShow2);
        return () => el.removeEventListener("shown.bs.offcanvas", onShow, onShow2);
    }, []);

    const handleReset = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match.");
            return;
        }

        try {
            await authApi.resetPassword({ email, newPassword });
            toast.success("Password updated!");

            // modal kapat + yönlendir
            const current = window.bootstrap?.Offcanvas.getInstance(document.getElementById("newPasswordModal"));
            current?.hide();

            localStorage.removeItem("resetEmail");
            navigate("/");
        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to reset password.");
        }
    };

    return (
        <div className="offcanvas offcanvas-end popup-style-1 input-page" id="newPasswordModal">
            <div className="canvas-wrapper">
                <div className="canvas-header popup-header">
                    <span className="title">Set New Password</span>
                </div>
                <div className="canvas-body popup-inner">
                    <form onSubmit={handleReset} className="form-login">
                        <fieldset className="password mb_12">
                            <input
                                type="password"
                                placeholder="New Password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                        </fieldset>
                        <fieldset className="password mb_12">
                            <input
                                type="password"
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                        </fieldset>
                        <div className="button-wrap">
                            <button className="subscribe-button tf-btn animate-btn bg-dark-2 w-100" type="submit">
                                Save New Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
